/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            redirect: '/moje-produkty',
            component: () => import('./layouts/main/Main.vue'),
            meta: {
                authRequired: true
            },
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/moje-produkty',
                    name: 'Baza produktów',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Moje produkty', active: true},
                        ]
                    },
                    component: () => import('./views/products/list.vue')
                },
                {
                    path: '/moje-produkty/dodaj',
                    name: 'Dodawanie produktu',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Moje produkty', active: true},
                        ]
                    },
                    component: () => import('./views/products/edit.vue')
                },
                {
                    path: '/baza-skladnikow',
                    name: 'Baza skladnikow',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Baza składników', active: true},
                        ]
                    },
                    component: () => import('./views/ingredients/list.vue')
                },
                {
                    path: '/global-allergens',
                    name: 'global-allergens',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Alergeny globalne', active: true},
                        ]
                    },
                    component: () => import('./views/globalAllergens/globalAllergens.vue')
                },
                {
                    path: '/moje-produkty/edytuj/:id',
                    name: 'Edycja produktu',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Moje produkty', url: '/moje-produkty'},
                            {title: 'Edycja', active: true},
                        ]
                    },
                    component: () => import('./views/products/edit.vue')
                },
                {
                    path: '/moje-konto',
                    name: 'Moje konto',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Moje konto', active: true},
                        ]
                    },
                    component: () => import('./views/user/user-edit/UserEdit.vue')
                },
                {
                    path: '/moje-produkty/podsumowanie/:id',
                    name: 'Podsumowanie',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Moje konto', url: '/moje-konto'},
                            {title: 'Podsumowanie', active: true},
                        ]
                    },
                    component: () => import('./views/user/user-edit/UserCheckout.vue')
                },
                {
                    path: '/kontakt',
                    name: 'Kontakt',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Kontakt', active: true},
                        ]
                    },
                    component: () => import('./views/contact/contact.vue')
                },
                {
                    path: '/subscriptions',
                    name: 'Użytkownicy',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Użytkownicy', active: true},
                        ]
                    },
                    component: () => import('./views/subscriptions/subscriptions.vue')
                },
                {
                    path: '/faktury',
                    name: 'Faktury',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Faktury', active: true},
                        ]
                    },
                    component: () => import('./views/faktury/faktury.vue')
                },
                {
                    path: '/users',
                    name: 'Users',
                    meta: {
                        authRequired: true,
                        breadcrumb: [
                            {title: 'Home', url: '/'},
                            {title: 'Users', active: true},
                        ]
                    },
                    component: () => import('./views/user/Users.vue')
                }
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [

                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/password-reset',
                    redirect: '',
                    component: () => import('./views/user/PasswordReset.vue'),
                    breadcrumb: [
                        {title: 'Home', url: '/'},
                        {title: 'resetowania hasła', active: true},
                    ]
                },
                {
                    path: '/callback',
                    name: 'auth-callback',
                    component: () => import('@/views/Callback.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/aktywuj/:code',
                    name: 'page-confirm',
                    component: () => import('@/views/login/Login.vue')
                },
                {
                    path: '/wyloguj',
                    name: 'page-logout',
                    component: () => import('@/views/logout/Logout.vue')
                },
                {
                    path: '/logowanie',
                    name: 'page-login',
                    component: () => import('@/views/login/Login.vue')
                },
                {
                    path: '/rejestracja',
                    name: 'page-register',
                    component: () => import('@/views/register/Register.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})


router.beforeEach((to, from, next) => {
    if (to.meta.authRequired) {
        if (!(auth.isAuthenticated())) {
            router.push({path: '/logowanie'})
        }
    }

    return next();
})


router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})
export default router
